import { SvgIconComponent } from '@mui/icons-material';
import { Button, SxProps, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { BUTTON_VARIANTS } from '../constants/constants';
import { V } from '../Layout';
import { useStyling } from '../Theme';

type ButtonWithIconProps = {
    label: ReactElement | string;
    onClick: () => void;
    Icon: SvgIconComponent;
    buttonContained?: boolean;
    sx?: SxProps;
    variant?: keyof typeof BUTTON_VARIANTS;
    fontSize?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    previewLabelInMobile?: boolean;
};

export default function ButtonWithIcon({
    label,
    onClick,
    Icon,
    buttonContained,
    variant,
    sx,
    fontSize = 'medium',
    disabled = false,
    previewLabelInMobile = true
}: ButtonWithIconProps) {
    const { isMobile } = useStyling();
    const previewLabel = !isMobile || previewLabelInMobile;

    return (
        <V sx={{ alignItems: 'center', ...sx }}>
            <Button
                data-testid="btn-add-status-note"
                variant={variant || (buttonContained ? BUTTON_VARIANTS.contained : BUTTON_VARIANTS.outlined)}
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    event.stopPropagation();
                    onClick();
                }}
                sx={{ gap: 1, px: 1, py: 0.5, minWidth: 'unset' }}
                disabled={disabled}
            >
                <Icon fontSize={fontSize} />
                {previewLabel && <Typography sx={{ textTransform: 'capitalize' }}>{label}</Typography>}
            </Button>
        </V>
    );
}
